<template>
  <v-app>
    <portal-target name="printcard"></portal-target>

    <v-content :class="['main-content', { appHidden: !show }]">
      <transition name="fade-transition">
        <router-view />
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import Config from '@/modules/config/models/Config'

export default {
  name: 'App',
  data() {
    return {
      show: false
    }
  },
  async beforeCreate() {
    await Config.dispatch('get')
    this.$store.state.useBadges = Config.value('useBadge') === 'true'
    console.log('this.$store.state.useBadges', this.$store.state.useBadges)
    this.$store.state.bucketUrl = Config.value('bucketUrl')
    this.$store.state.lessonTerm = Config.value('lessonTerm')
      ? Config.value('lessonTerm')
      : 'lesson'
    document.title = Config.value('title')
    const theme = {
      primary: Config.value('primary'),
      secondary: Config.value('secondary'),
      third: Config.value('third'),
      error: Config.value('error'),
      correct: Config.value('correct'),
      incorrect: Config.value('incorrect'),
      success: Config.value('success')
    }
    // this.$vuetify.themes.theme.dark = theme
    this.$vuetify.theme.themes.light = theme
    this.setFavicon(
      'image/x-icon',
      'icon',
      null,
      this.$store.state.bucketUrl + '/brand/favicon.ico'
    )
    this.setFavicon(
      null,
      'apple-touch-icon',
      '180x180',
      this.$store.state.bucketUrl + '/brand/favicon-180x180.png'
    )
    const faviconSizes = ['16x16', '32x32', '192x192', '512x512']
    faviconSizes.forEach(sizes => {
      this.setFavicon(
        null,
        'icon',
        sizes,
        `${this.$store.state.bucketUrl}/brand/favicon-${sizes}.png`
      )
    })
    // await setTimeout(() => {
    //   this.$store.state.bucketUrl =
    //     'https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint'
    //   this.$vuetify.theme = {
    //     primary: '#00A3AD',
    //     secondary: '#FDCC08',
    //     third: '#006280',
    //     error: '#b71c1c',
    //     correct: '#172659',
    //     incorrect: '#FF6E7E',
    //     success: '#00A3AD'
    //   }

    //   // add style to document
    //   const css = `
    // @font-face {
    //   font-family: 'FFMarkWebPro';
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/regular.eot');
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/regular.eot?#iefix') format('embedded-opentype'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/regular.woff2') format('woff2'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/regular.woff') format('woff'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/regular.ttf') format('truetype');
    //   font-style: normal;
    //   font-weight: 400;
    // }

    // @font-face {
    //   font-family: 'FFMarkWebPro';
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/light.eot');
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/light.eot?#iefix') format('embedded-opentype'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/light.woff2') format('woff2'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/light.woff') format('woff'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/light.ttf') format('truetype');
    //   font-style: normal;
    //   font-weight: 100;
    // }

    // @font-face {
    //   font-family: 'FFMarkWebPro';
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/medium.eot');
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/medium.eot?#iefix') format('embedded-opentype'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/medium.woff2') format('woff2'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/medium.woff') format('woff'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/medium.ttf') format('truetype');
    //   font-style: normal;
    //   font-weight: 500;
    // }

    // @font-face {
    //   font-family: 'FFMarkWebPro';
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.eot');
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.eot?#iefix') format('embedded-opentype'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.woff2') format('woff2'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.woff') format('woff'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.ttf') format('truetype');
    //   font-style: normal;
    //   font-weight: 700;
    // }

    // @font-face {
    //   font-family: 'FFMarkWebPro';
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.eot');
    //   src: url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.eot?#iefix') format('embedded-opentype'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.woff2') format('woff2'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.woff') format('woff'),url('https://kelms-api-storage-public.s3-ap-southeast-2.amazonaws.com/digitalthumbprint/fonts/heavy.ttf') format('truetype');
    //   font-style: normal;
    //   font-weight: 900;
    // }

    // html {
    //   font-family: 'FFMarkWebPro', Arial, Helvetica, sans-serif;
    // }

    // body {
    //   font-family: 'FFMarkWebPro', Arial, Helvetica, sans-serif;
    // }

    // html body .application {
    //   font-family: 'FFMarkWebPro', Arial, Helvetica, sans-serif;
    // }

    // .lesson-progress.cyberbullying-and-respectful-relationships .v-progress-linear__background, .lesson-progress.cyberbullying-and-respectful-relationships .v-progress-linear__determinate {
    //   background-color: #FFD32D !important;
    // }

    // .lesson-progress.digital-identity .v-progress-linear__background, .lesson-progress.digital-identity .v-progress-linear__determinate {
    //   background-color: #80276C !important;
    // }

    // .lesson-progress.digital-discernment .v-progress-linear__background, .lesson-progress.digital-discernment .v-progress-linear__determinate {
    //   background-color: #006280 !important;
    // }

    // .lesson-progress.digital-balance .v-progress-linear__background, .lesson-progress.digital-balance .v-progress-linear__determinate {
    //   background-color: #172659 !important;
    // }

    // .lesson-progress.cybersecurity .v-progress-linear__background, .lesson-progress.cybersecurity .v-progress-linear__determinate {
    //   background-color: #26b0b9 !important;
    // }

    // html body .lesson-card-wrap .lesson-image h5.lesson-title {
    //   display: none;
    //   display: inline-block;
    //   padding: 0;
    //   padding-bottom: 10px;
    //   line-height: 14px;
    //   color: white;
    //   padding-right: 10px;
    // }

    // .lesson-card-wrap.digital-identity .lesson-image h5 {
    //   background-color: var(--v-primary-base);
    // }

    // .lesson-card-wrap.digital-discernment .lesson-image h5 {
    //   background-color: var(--v-primary-base);
    // }

    // .lesson-card-wrap.cybersecurity .lesson-image h5 {
    //   background-color: var(--v-primary-base);;
    // }

    // .lesson-card-wrap.digital-balance .lesson-image h5 {
    //   background-color: white;
    // }

    // .lesson-card-wrap.cyberbullying-and-respectful-relationships .lesson-image h5 {
    //   background-color: white;
    // }

    // .optus-highlight {
    //   display: inline-block;
    //   padding-bottom: 0.25em;
    //   line-height: 0.47em;
    //   background-color: var(--v-primary-base);
    //   color: white;
    //   letter-spacing: -1px;
    // }

    // .optus-highlight--yellow {
    //   background-color: var(--v-secondary-base);
    //   color: var(--v-primary-base);
    // }

    // .header-title {
    //   font-size: 3em;
    // }

    // html body .headline, html body .title, html body .subheading, html body .display-4, html body .display-3, html body .display-2, html body .display-1 { font-family: 'FFMarkWebPro', Arial, Helvetica, sans-serif !important; }
    //   `
    // }, 2000)
    this.show = true
    const css = Config.value('style')
    const head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')
    style.type = 'text/css'
    if (style.styleSheet) {
      // This is required or IE8 and below.
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }
    head.appendChild(style)
  },
  methods: {
    setFavicon(type, rel, sizes, url) {
      var link = document.createElement('link')
      if (type) link.type = type
      if (rel) link.rel = rel
      if (sizes) link.sizes = sizes
      link.href = url
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
</script>

<style lang="scss">
// DASHBOARD CSS
.full-loading {
  z-index: 999;
  background: rgba(255, 255, 255, 0.1);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    span {
      font-size: 30px;
      text-transform: uppercase;
      color: var(--v-primary-base);
      display: block;
      text-align: center;
      margin-top: 20px;
    }
  }
}
.main-content {
  position: relative;
  min-height: 82vh;
}
// END DASHBOARD CSS

.border-radius-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.border-radius-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.border-radius-0 {
  border-radius: 0 !important;
}

.header-title {
  color: var(--v-secondary-base);
  font-size: 3em;
}

.appHidden {
  visibility: hidden;
}

.signup {
  .terms-and-conditions {
    label {
      display: block !important;
      width: 90%;
    }
  }
}

// FIREFOX FIX
.v-btn--floating .v-icon {
  height: initial;
}
</style>
